import React from 'react';
import { BrowserRouter, Routes, Route, useSearchParams } from 'react-router-dom';
import SiftApp from './SiftApp';
import LandingPage from './pages/LandingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { Toaster } from './components/ui/sonner';
import { ShopifyBridgeProvider } from './sift/components/ShopifyBridge';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LoginPage from './auth/LoginPage';

function ProtectedApp() {
  const [searchParams] = useSearchParams();
  const host = searchParams.get('host');
  const shop = searchParams.get('shop');
  const isDemo = searchParams.get('demo') === 'true';
  const isDemoLite = searchParams.get('demo') === 'lite';
  const isEmbedded = Boolean(host) && window.top !== window.self;

  const { isAuthenticated, loading } = useAuth();

  // Demo mode — skip auth so prospects can try the interactive demo
  if (isDemo || isDemoLite) {
    return <SiftApp initialMode={isDemoLite ? 'lite' : 'full'} />;
  }

  // If running inside Shopify admin, skip our auth gate (Shopify handles auth)
  if (isEmbedded) {
    return (
      <ShopifyBridgeProvider host={host} shop={shop}>
        <SiftApp />
      </ShopifyBridgeProvider>
    );
  }

  // Show loading spinner while verifying token
  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div style={{ width: 32, height: 32, border: '3px solid #e5e7eb', borderTopColor: '#1a1a1a', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  // Require login for standalone access
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <SiftApp />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/app" element={<ProtectedApp />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
